import DropdownList from "../../CommonElements/Dropdown";

const Searchbar = () => {
  return (
    <div className="left-side-header ps-0 dash-10 d-flex align-items-center gap-3 flex-fill">
      <div className="d-none d-md-block">
        <DropdownList />
      </div>
    </div>
  );
};

export default Searchbar;
